function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M52.729,20.146c-1.051-7.759-6.703-14.164-13.803-17.978c-0.358-0.192-0.72-0.371-1.087-0.538 c-2.07-0.938-9.501-1.5-12.745-1.609C24.978,0.018,24.86,0,24.744,0h0c-0.057,0-0.115,0.005-0.172,0.006 C24.401,0.002,24.243,0,24.113,0l0.006,0.022c-0.463,0.02-0.926,0.054-1.387,0.117c-1.153,0.158-2.289,0.446-3.396,0.85 C10.509,4.208,3.575,11.784,3.132,21.261C2.954,25.073,4,28.836,5.854,32.172c2.299,4.137,6.466,12.205,6.189,15.882 c-0.058,0.763-0.028,1.488,0.161,2.141c0.993,3.43,3.363,5.805,6.54,5.805c0.124,0,0.238-0.034,0.358-0.05L19.113,56h4.078 c1.062,0,1.922-0.861,1.922-1.922l0-7.93c0-0.961,0.202-1.927,0.687-2.757c1.482-2.533,0.048-4.542,0.357-8.736 c0.158-2.143,3.317-2.278,3.545-0.141c0.028,0.259,0.042,0.522,0.042,0.79l-2.312,15.778c-0.376,2.291,0.887,4.426,2.696,4.833 L37.113,56c3.176,0,5.178-2.375,6.171-5.805c0.148-0.51,0.187-1.06,0.161-1.633c-0.168-3.603,4.294-11.903,6.68-16.064 C52.27,28.755,53.308,24.422,52.729,20.146z",
    fill: "#445A66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(98, 68, 50)"
    },
    d: "M22.732,0.139c-1.153,0.158-2.289,0.446-3.396,0.85C10.509,4.208,3.575,11.784,3.132,21.261 C2.954,25.073,4,28.836,5.854,32.172c2.299,4.137,6.466,12.205,6.189,15.882c-0.058,0.763-0.028,1.488,0.161,2.141 c0.993,3.43,3.363,5.805,6.54,5.805h0c2.131,0,3.73-2.374,3.312-4.918l-2.312-15.778c0-3.362,2.239-6.087,5-6.087h0 c2.761,0,5,2.725,5,6.087l-2.312,15.778C27.014,53.626,28.612,56,30.744,56h0c3.176,0,5.547-2.375,6.54-5.805 c0.148-0.51,0.187-1.059,0.161-1.633c-0.168-3.602,4.294-11.903,6.68-16.064c2.146-3.743,3.184-8.077,2.605-12.352 c-1.051-7.759-6.703-14.164-13.803-17.978c-0.358-0.192-0.72-0.371-1.087-0.538C29.521,0.581,27.094,0,24.744,0h0 C24.073,0,23.401,0.047,22.732,0.139z",
    fill: "#FFD3B9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M23.743,16.043v-3.936C17.988,12.265,11.498,13.617,4.487,17c-0.225,0.109-0.469,0.115-0.694,0.054 c-0.356,1.354-0.593,2.755-0.661,4.207c-0.001,0.032,0.001,0.064-0.001,0.096C10.637,17.65,17.601,16.198,23.743,16.043z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M23.743,5.033V0.035c-0.338,0.023-0.675,0.058-1.012,0.104c-1.153,0.158-2.289,0.446-3.396,0.85 C15.305,2.459,11.678,4.846,8.874,7.9C14.203,5.98,19.191,5.151,23.743,5.033z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M6.53,33.408c0.57,1.054,1.199,2.254,1.827,3.527c0.29-0.14,0.634-0.154,0.934,0.022 c2.454,1.438,6.386,3.251,11.256,3.834l-0.587-4.008l-0.251-0.026C15.163,36.291,10.738,35.161,6.53,33.408z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M23.743,7.037c-4.802,0.13-10.106,1.074-15.805,3.346c-0.333,0.135-0.691,0.059-0.962-0.145 c-0.996,1.414-1.823,2.938-2.455,4.553c6.976-3.22,13.453-4.54,19.222-4.691V7.037z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M46.164,17.456c-0.098,0.031-0.199,0.052-0.302,0.052c-0.163,0-0.329-0.04-0.482-0.125 c-4.212-2.324-11.021-5.104-19.636-5.278v3.93c9.726,0.191,17.172,3.524,21.128,5.786c-0.022-0.558-0.067-1.117-0.142-1.674 C46.605,19.229,46.411,18.333,46.164,17.456z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M25.743,10.098c8.374,0.162,15.123,2.683,19.585,4.993c-0.716-1.703-1.656-3.31-2.777-4.807 c-0.174,0.134-0.385,0.215-0.606,0.215c-0.131,0-0.264-0.025-0.392-0.08c-4.059-1.726-9.443-3.264-15.81-3.392V10.098z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M25.743,5.022c5.75,0.111,10.732,1.326,14.726,2.816c-2.16-2.243-4.735-4.162-7.544-5.671 c-0.358-0.192-0.72-0.371-1.087-0.538c-1.991-0.902-4.061-1.431-6.095-1.57V5.022z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M27.72,53.711C28.267,55.05,29.397,56,30.744,56h0c2.935,0,5.166-2.04,6.274-5.054 C33.935,52.359,30.813,53.29,27.72,53.711z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M29.009,42.516c-0.061,0.011-0.12,0.016-0.179,0.016c-0.049,0-0.094-0.018-0.142-0.025L28.1,46.521 c3.309-0.53,6.634-1.659,9.888-3.37c0.265-0.139,0.561-0.138,0.82-0.038c0.705-1.772,1.605-3.672,2.519-5.464 C37.271,40.133,33.134,41.771,29.009,42.516z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M27.947,48.563c-0.049,0-0.094-0.019-0.142-0.026l-0.373,2.545 c-0.036,0.222-0.039,0.439-0.045,0.656c3.169-0.425,6.383-1.419,9.554-2.961c0.162-0.079,0.333-0.094,0.501-0.083 c-0.001-0.045,0.005-0.087,0.002-0.132c-0.039-0.84,0.181-1.943,0.561-3.182c-3.261,1.606-6.59,2.677-9.909,3.171 C28.045,48.559,27.995,48.563,27.947,48.563z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M21.717,48.776c-0.048,0.007-0.092,0.027-0.142,0.027c-0.025,0-0.052-0.001-0.078-0.003 c-3.253-0.252-6.465-1.059-9.561-2.386c0.1,0.608,0.142,1.162,0.106,1.64c-0.042,0.564-0.036,1.105,0.045,1.614 c0.212-0.059,0.44-0.064,0.658,0.028c3.015,1.29,6.152,2.044,9.326,2.241c0.015,0.001,0.028,0.01,0.043,0.011 c0.003-0.285-0.012-0.574-0.06-0.867L21.717,48.776z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M29.801,36.686c-0.039,0.005-0.077,0.007-0.115,0.007c-0.05,0-0.094-0.019-0.142-0.026 l-0.558,3.811c4.247-0.818,8.523-2.64,12.713-5.432c0.318-0.211,0.708-0.205,1.023-0.037c0.414-0.761,0.807-1.463,1.165-2.092 C39.229,34.873,34.497,36.146,29.801,36.686z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M12.091,44.303c3.017,1.376,6.156,2.202,9.333,2.475l-0.583-3.982 c-0.048,0.007-0.092,0.026-0.142,0.026c-0.036,0-0.073-0.002-0.109-0.006c-3.786-0.414-7.59-1.608-11.089-3.46 c0.76,1.683,1.439,3.375,1.907,4.905C11.628,44.2,11.867,44.2,12.091,44.303z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M29.718,34.68c4.838-0.572,9.722-1.944,14.519-4.085c0.28-0.126,0.579-0.101,0.835,0.022 c0.954-2.112,1.559-4.36,1.741-6.652c-0.155-0.008-0.311-0.048-0.453-0.132c-3.629-2.147-10.939-5.596-20.616-5.793v5.178 c0,0.553-0.447,1-1,1s-1-0.447-1-1v-5.168c-5.997,0.159-12.812,1.595-20.17,5.308c-0.128,0.064-0.263,0.096-0.397,0.104 c0.197,2.658,0.951,5.255,2.135,7.661c0.261-0.135,0.572-0.167,0.861-0.038c4.074,1.828,8.377,3.03,12.806,3.577 c0.152-0.181,0.368-0.309,0.62-0.346c0.075-0.012,0.144,0.005,0.216,0.01c0.385-2.895,2.442-5.108,4.929-5.108h0 C27.332,29.217,29.461,31.611,29.718,34.68z",
    fill: "#FFA89C"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(239, 83, 80)"
    },
    d: "M12.864,51.879c1.203,2.49,3.26,4.121,5.88,4.121c1.279,0,2.355-0.863,2.93-2.095 C18.681,53.69,15.725,53,12.864,51.879z",
    fill: "#FFA89C"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(98, 68, 50)"
    },
    d: "M24.638,23.355c-3.599,0-6.527,2.635-6.527,5.874c0,0.94,0.25,1.854,0.72,2.675 c1.467-1.913,3.568-3.044,5.807-3.044s4.341,1.131,5.807,3.044c0.47-0.822,0.72-1.735,0.72-2.675 C31.165,25.99,28.237,23.355,24.638,23.355z",
    fill: "#FFD3B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuna);
export default __webpack_public_path__ + "static/media/tuna.78adaca6c05bd1ef8be2146017f643af.svg";
export { ForwardRef as ReactComponent };